<ng-container *transloco="let t">
  <div class="container" [ngClass]="{'small': options.length > 6}">
    @for (option of options; track $index; let i = $index) {
      <app-fancy-button
        class="selectable"
        [title]="getTitle(option)"
        [selected]="getSelected(option)"
        (selectedChange)="setSelected(option, $event)"
        [icon]="getIcon(option)"
        [type]="getType(option)"
        [text]="getText(option)"
        (click)="onClick(i)"/>
    }
  </div>
  @let hint = selectedOptionHasHint();
  @if (hint) {
    <div class="hint">
      <p>{{ hint }}</p>
    </div>
  }
  @if (showErrorMessage && !isValid) {
    <div class="error">
      <img src="/assets/warning.png">
      <p>{{ t('VALIDATION.ERROR-MSG') }}</p>
    </div>
  }
</ng-container>
